import React, { useContext, useEffect, useState } from 'react';
import { orgCount } from 'api/UserController';
import { message } from 'antd';
import { AuthContext } from 'contexts';
import ManageDeletedStaffList from './ManageDeletedStaffList';
import ManageStaffList from './ManageStaffList';

interface ManageAnsweringStaffProps {
  deletedPage?: boolean;
}

const ManageAnsweringStaff: React.FC<ManageAnsweringStaffProps> = ({
  deletedPage,
}) => {
  const [activeCount, setActiveCount] = useState<number>();
  const [deletedCount, setDeletedCount] = useState<number>();
  const { auth } = useContext(AuthContext);

  const fetchUserCounts = async () => {
    try {
      const { active, deleted } = await orgCount({
        forAnsweringStaff: true,
      });
      setActiveCount(active);
      setDeletedCount(deleted);
    } catch (err) {
      message.error('Error fetching staff counts');
    }
  };

  useEffect(() => {
    fetchUserCounts();
  }, []);

  return (
    <div className="global--angular">
      {deletedPage ? (
        <ManageDeletedStaffList active={activeCount} deleted={deletedCount} />
      ) : (
        <ManageStaffList
          auth={auth}
          active={activeCount}
          deleted={deletedCount}
          fetchUserCounts={fetchUserCounts}
        />
      )}
    </div>
  );
};

export default ManageAnsweringStaff;
